import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';


import { Router } from '@angular/router';
 
import { BilldeskService } from '../../billdesk.service'; 


@Component({
  selector: 'app-price-type-entry',
  templateUrl: './price-type-entry.component.html',
  styleUrls: ['./price-type-entry.component.css']
})
export class PriceTypeEntryComponent implements OnInit {
  //Create FormGroup 

  countries: any[];
    
  form: FormGroup; 
  stateList:any[];
  visibleloader:boolean;
  cityList:any[];
  selectedCity: string;

  selectedCityName:string='Please Select City';
  
  selectedStateName: string='Please Select State';
  StateID:number;
  DistrictID:number;
  selectedState: string;
  constructor(private fb: FormBuilder,private http:HttpClient,private route : Router,private billdeskService:BilldeskService) {
    console.log(this.billdeskService.getState().then(res => this.stateList = res));
    
    console.log('statelistend');



  }
 
  //Create required field validator for name

  ngOnInit() {


        
  
    this.form = this.fb.group({ 
      
      PriceTypeName: [null, Validators.required], 
     
      ActiveStatus: [null, Validators.required],
     
      
    });
  }
 
  isFieldValid(field: string) {
    return !this.form.get(field).valid && this.form.get(field).touched;
  }
 
  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }
 
  onSubmit() {
   var obj1 = 
    {
       
      "PriceTypeID" :0,
    
    };
var obj2 = this.form.value;
var form_data = Object.assign(obj1, obj2);
        console.log("merge");
        console.log(form_data);
        console.log("merge"); 
        console.log(this.form);
        console.log(this.form.value.flag);
        
const datarequest={
  "CheckSum": "",
   "lead_id": "",
"ActionFor": "Insert",            
"dataobject":[
  
  form_data

]
 }
;
console.log("datarequest1");
console.log(datarequest);
console.log("datarequest1");
 console.log(this.form);
 
 
 if (this.form.valid) {


  this.visibleloader=true; 
   console.log('form submitted');
 let registerurl= "/pricetype/pricetyperegistration";
this.billdeskService.RegisterData(registerurl,datarequest).subscribe((res:any)=>{
  console.log("responce data");
  console.log(res);
  console.log("responce data");
   console.log(res.pricetyperegistrationResult);
  if(res.pricetyperegistrationResult.Message=='Sucess'){
   console.log('Insert Success');
   this.route.navigate(['/price_type_list'])
   localStorage.setItem('insertdata', 'Success');
  }else{
   console.log('Please Try Again Later');
 }
 });
} else {
   this.validateAllFormFields(this.form);
 }
  }

 
 
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      console.log(field);
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
 
  reset(){
    this.form.reset();
  }


  changeState(e) { 
console.log(e); 
 this.selectedState=e.value.StateID;


this.selectedStateName=e.value.StateName;
console.log(this.billdeskService.getCity(e.value.StateID).then(res => this.cityList = res));

  }

  changeCity(e) {

console.log(e); 
 
this.selectedCityName=e.value.DistrictName;



console.log(this.selectedCityName);
    this.selectedCity=e.value.DistrictID;
 
  }

 }
 